// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G8ear","tabsBox":"styles_tabsBox__3vAnJ","createButton":"styles_createButton__UbOnc"};